import {apiGet, apiPost} from "../../shared/api/client";

const DEFAULT_PAGE_SIZE = 20;

const cleanParams = (values) =>
    Object.fromEntries(
        Object.entries(values || {}).filter(([, value]) =>
            value !== "" && value !== null && value !== undefined,
        ),
    );

const scopedConfig = (countryId, idempotencyKey) => ({
    params: cleanParams({country_id: countryId}),
    ...(idempotencyKey ? {headers: {"Idempotency-Key": idempotencyKey}} : {}),
});

export const loadClubMembers = async ({countryId, page = 1, search = "", pageSize = DEFAULT_PAGE_SIZE} = {}) =>
    apiGet("/api/v2/admin/club-members", {
        params: cleanParams({
            country_id: countryId,
            page,
            search,
            // Дефолтный размер не отправляем: бэкенд и так вернёт 20,
            // а запросы существующих клиентов остаются байт-в-байт прежними.
            page_size: pageSize === DEFAULT_PAGE_SIZE ? undefined : pageSize,
        }),
    });

export const createClubMember = async ({phoneNumber, placesCount, countryId}) =>
    apiPost(
        "/api/v2/admin/club-members",
        {phone_number: phoneNumber, places_count: placesCount},
        scopedConfig(countryId),
    );

export const changeClubMemberPart = async ({userId, placesCount, countryId}) =>
    apiPost(
        `/api/v2/admin/club-members/${userId}/part`,
        {places_count: placesCount},
        scopedConfig(countryId),
    );

export const fillClubMemberBonus = async ({userId, amount, countryId, idempotencyKey}) =>
    apiPost(
        `/api/v2/admin/club-members/${userId}/fill-bonus`,
        {fill_sum: amount},
        scopedConfig(countryId, idempotencyKey),
    );

export const fillAllClubMemberBonuses = async ({amount, countryId, idempotencyKey}) =>
    apiPost(
        "/api/v2/admin/club-members/fill-bonus-all",
        {fill_sum: amount},
        scopedConfig(countryId, idempotencyKey),
    );

export const deleteClubMember = async ({userId, countryId}) =>
    apiPost(
        `/api/v2/admin/club-members/${userId}/delete`,
        undefined,
        scopedConfig(countryId),
    );
